import { apiClient } from './apiClient';
import {
  PurchaseOrder,
  CreatePurchaseOrderRequest,
  UpdatePurchaseOrderRequest,
  ReceiveItemsRequest,
  PurchaseOrderStatistics
} from '../types';

class PurchaseOrderService {
  async getPurchaseOrders(params?: {
    search?: string;
    status?: string;
    payment_status?: string;
    supplier_id?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<PurchaseOrder[]> {
    const response = await apiClient.get<PurchaseOrder[]>('/purchase-orders', { params });
    return response;
  }

  async getPurchaseOrder(id: number): Promise<PurchaseOrder> {
    const response = await apiClient.get<PurchaseOrder>(`/purchase-orders/${id}`);
    return response;
  }

  async createPurchaseOrder(data: CreatePurchaseOrderRequest): Promise<PurchaseOrder> {
    const response = await apiClient.post<{ purchase_order: PurchaseOrder }>('/purchase-orders', data);
    return response.purchase_order;
  }

  async updatePurchaseOrder(data: UpdatePurchaseOrderRequest): Promise<PurchaseOrder> {
    const { id, ...updateData } = data;
    const response = await apiClient.put<{ purchase_order: PurchaseOrder }>(`/purchase-orders/${id}`, updateData);
    return response.purchase_order;
  }

  async deletePurchaseOrder(id: number): Promise<void> {
    await apiClient.delete(`/purchase-orders/${id}`);
  }

  async receiveItems(id: number, data: ReceiveItemsRequest): Promise<PurchaseOrder> {
    const response = await apiClient.post<{ purchase_order: PurchaseOrder }>(`/purchase-orders/${id}/receive`, data);
    return response.purchase_order;
  }

  async cancelPurchaseOrder(id: number): Promise<PurchaseOrder> {
    const response = await apiClient.post<{ purchase_order: PurchaseOrder }>(`/purchase-orders/${id}/cancel`);
    return response.purchase_order;
  }

  async getStatistics(): Promise<PurchaseOrderStatistics> {
    const response = await apiClient.get<PurchaseOrderStatistics>('/purchase-orders/statistics');
    return response;
  }
}

export const purchaseOrderService = new PurchaseOrderService();
